<qaroni-query-param-select-object-filter
  class="w-full lg:w-fit"
  [options]="workplaces$ | async"
  [label]="workplaceFilterLabel()"
  textKey="name"
  valueKey="workplaceId"
  [multiple]="multiple()"
  [queryParamName]="queryParamName()"
  (queryParamsChange)="onQueryParamsChange($event)" />
